import { Navigate, Outlet } from 'react-router-dom'
import { useUser } from 'app/utils'

export let handle = {
  breadcrumb: `Operations`,
  title: `Operations`,
}

export default function Ops(): React.ReactElement {
  const user = useUser()

  // Never render an Ops page for a non-super user, not even for the frame before a
  // redirect: its data would start loading. The API enforces this too.
  if (user?.type !== `super`) return <Navigate to="/" replace />

  return <Outlet />
}
